import React from 'react'
import PropTypes from 'prop-types'

export default function OrderRow ({ children }) {
    return (
        <div className={'mtt-order-row'}>
            { children }
        </div>
    )
}

OrderRow.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string])
}